export class Register {
  public FullName: string;
  public CompanyName: string;
  public Email: string;
  public Telephone: string;
  public Postcode: string;
  public EnquiryDetail: string;
  public DecisionMaker: string;
  public FuelCardHolder: string;
  public AccountNumber: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/register/register.ts